import {
  Box,
  Button,
  DialogDescription,
  DialogTitle,
} from '@branch-messenger/willow-ui'
import { VisuallyHidden } from '@radix-ui/react-visually-hidden'
import { use } from 'react'

import { DialogContext } from '@/context'

import { DebitCardInformation } from '../DebitCard/DebitCardInformation'
import { DebitCardModalContent } from './DebitCardModalContent'

export const DirectCardPrimerModalContent = () => {
  const { hideDialog, showDialog } = use(DialogContext)
  const handleContinue = () => {
    showDialog({
      children: <DebitCardModalContent type="PAYOUT_CARD" />,
      hideCloseButton: true,
    })
  }

  return (
    <Box $display="flex" $direction="column" $gap={6} $align="stretch">
      <VisuallyHidden>
        <DialogTitle>Debit card</DialogTitle>
        <DialogDescription>
          Information about connecting your debit card
        </DialogDescription>
      </VisuallyHidden>
      <DebitCardInformation />
      <Box $display="flex" $gap={2} $justify="flex-end">
        <Button onClick={hideDialog} variant="outlined" color="tertiary">
          Cancel
        </Button>
        <Button onClick={handleContinue}>Continue</Button>
      </Box>
    </Box>
  )
}
